import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const HAS_DAMAGE_PHOTOS = {
  YES: 'yes',
  NO: 'no',
} as const;

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const HAS_DAMAGE_PHOTOS_NAME = 'has_damage_photos';

export const RadioGroupHasDamagePhotos: FC<Props> = ({
  name = HAS_DAMAGE_PHOTOS_NAME,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{i18n.t('Czy posiadasz zdjęcia uszkodzeń?')}</FormLabel>
          <FormControl>
            <RadioGroup
              {...field}
              layout={'horizontal'}
              data-testid="radio-group-has-damage-photos"
            >
              <RadioItem
                value={HAS_DAMAGE_PHOTOS.YES}
                label={i18n.t('Tak')}
                data-testid="radio-item-has-damage-photos-yes"
              />
              <RadioItem
                value={HAS_DAMAGE_PHOTOS.NO}
                label={i18n.t('Nie')}
                data-testid="radio-item-has-damage-photos-no"
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
